import React from "react";
import NewsList from "@components/News/NewsList";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const NewsPage = () => {

    return (
        <VersionedLayout>
            <NewsList />
        </VersionedLayout>
    );
};

export default NewsPage;
